// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e2541bc7","455":"c4d4d298","977":"0077a056"}[chunkId] + ".chunk.js";
};